<template>
  <div class="mb-100">

    <div class="row my-gd-4">
      <div class="col-12"><TitleSidebar :label="'Text'" /></div>
      <div class="col-12">
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Component'"
          :split="'2:5'"
        >
          <TitleSidebar class="mt-gd-1" :tag="'div'" :label="'TitleSidebar'" />
          <TitleModal class="mt-gd-1" :tag="'div'" :label="'TitleModal'" />
          <TitleDesign class="mt-gd-1" :tag="'div'" :label="'TitleDesign'" />
          <TitleSetting class="mt-gd-1" :tag="'div'" :label="'TitleSetting'" />
          <FormLabel class="mt-gd-1" :tag="'div'" :label="'FormLabel'" />
          <FormLabel class="mt-gd-1" :tag="'div'" :label="'FormLabel'" :labelFont="'fs-dbb-20'" />
        </FormGroupHorizontal>
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Color'"
          :split="'2:10'"
        >
          <div class="row">
            <div class="col-4">
              <div class="text-black"><span class="d-inline-block" style="width: 80px;">#000000</span>text-black</div>
              <div class="text-black-light"><span class="d-inline-block" style="width: 80px;">#373E44</span>text-black-light</div>
              <div class="text-black-lighten"><span class="d-inline-block" style="width: 80px;">#53585D</span>text-black-lighten</div>
              <div class="text-white bg-black-lighten"><span class="d-inline-block" style="width: 80px;">#FFFFFF</span>text-white</div>
              <div class="text-white-dark bg-black-lighten"><span class="d-inline-block" style="width: 80px;">#F8F9FA</span>text-white-dark</div>
              <div class="text-blue"><span class="d-inline-block" style="width: 80px;">#24BEE2</span>text-blue</div>
              <div class="text-blue-dark"><span class="d-inline-block" style="width: 80px;">#009CC1</span>text-blue-dark</div>
              <!-- <div class="text-blue-light bg-black-lighten"><span class="d-inline-block" style="width: 80px;">#EAF9FB</span>text-blue-light</div> -->
              <!-- <div class="text-blue-disabled"><span class="d-inline-block" style="width: 80px;">#72D5EC</span>text-blue-disabled</div> -->
              <div class="text-blue2"><span class="d-inline-block" style="width: 80px;">#12A9FF</span>text-blue2</div>
              <div class="text-blue2-dark"><span class="d-inline-block" style="width: 80px;">#0B77B5</span>text-blue2-dark</div>
              <!-- <div class="text-blue2-light bg-black-lighten"><span class="d-inline-block" style="width: 80px;">#F4FCFF</span>text-blue2-light</div> -->
              <!-- <div class="text-blue2-disabled"><span class="d-inline-block" style="width: 80px;">#ADDFFC</span>text-blue2-disabled</div> -->
              <div class="text-purple"><span class="d-inline-block" style="width: 80px;">#6076FE</span>text-purple</div>
              <div class="text-green"><span class="d-inline-block" style="width: 80px;">#5FB412</span>text-green</div>
              <div class="text-green-dark"><span class="d-inline-block" style="width: 80px;">#5C932E</span>text-green-dark</div>
              <div class="text-yellow"><span class="d-inline-block" style="width: 80px;">#FFC107</span>text-yellow</div>
              <div class="text-orange"><span class="d-inline-block" style="width: 80px;">#FF9601</span>text-orange</div>
              <div class="text-orange-dark"><span class="d-inline-block" style="width: 80px;">#A66D2D</span>text-orange-dark</div>
              <div class="text-red"><span class="d-inline-block" style="width: 80px;">#D9534F</span>text-red</div>
              <div class="text-red-dark"><span class="d-inline-block" style="width: 80px;">#A03E3B</span>text-red-dark</div>
            </div>
            <div class="col-4">
              <div class="text-dark"><span class="d-inline-block" style="width: 80px;">#53585D</span>text-dark</div>
              <div class="text-darken"><span class="d-inline-block" style="width: 80px;">#373E44</span>text-darken</div>
              <div class="text-light bg-black-lighten"><span class="d-inline-block" style="width: 80px;">#F8F9FA</span>text-light</div>
              <div class="text-primary"><span class="d-inline-block" style="width: 80px;">#24BEE2</span>text-primary</div>
              <div class="text-secondary"><span class="d-inline-block" style="width: 80px;">#12A9FF</span>text-secondary</div>
              <div class="text-active"><span class="d-inline-block" style="width: 80px;">#009CC1</span>text-active</div>
              <div class="text-success"><span class="d-inline-block" style="width: 80px;">#5FB412</span>text-success</div>
              <div class="text-warning"><span class="d-inline-block" style="width: 80px;">#FF9601</span>text-warning</div>
              <div class="text-danger"><span class="d-inline-block" style="width: 80px;">#D9534F</span>text-danger</div>
            </div>
            <div class="col-4">
              <div class="text-default"><span class="d-inline-block" style="width: 80px;">#373E44</span>text-default</div>
              <div class="text-heading"><span class="d-inline-block" style="width: 80px;">#373E44</span>text-heading</div>
              <div class="text-paragraph"><span class="d-inline-block" style="width: 80px;">#53585D</span>text-paragraph</div>
              <div class="text-placeholder"><span class="d-inline-block" style="width: 80px;">#A5A5A5</span>text-placeholder</div>
              <div class="text-hint"><span class="d-inline-block" style="width: 80px;">#84929F</span>text-hint</div>
              <div class="text-muted"><span class="d-inline-block" style="width: 80px;">#8E969E</span>text-muted</div>
              <div class="text-disabled"><span class="d-inline-block" style="width: 80px;">#6C757D</span>text-disabled</div>
              <div class="text-link"><span class="d-inline-block" style="width: 80px;">#007BFF</span>text-link</div>
            </div>
          </div>
        </FormGroupHorizontal>
      </div>
    </div>

    <div class="row my-gd-4">
      <div class="col-12"><TitleSidebar :label="'Button'" /></div>
      <div class="col-12">
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Size'"
          :split="'2:10'"
        >
          <b-button variant="default" size="sm">small</b-button>
          <b-button variant="default">default</b-button>
          <b-button variant="default" size="lg">large</b-button>
        </FormGroupHorizontal>
      </div>
      <div class="col-12">
        <TitleSidebar class="mt-gd-2" :tag="'div'" :label="'Color'" />
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Normal'"
          :split="'2:10'"
        >
          <b-button variant="default">default</b-button>
          <b-button variant="blue">blue</b-button>
          <b-button variant="lightBlue">lightBlue</b-button>
          <b-button variant="dark">dark</b-button>
          <b-button variant="orange">orange</b-button>
          <b-button variant="danger">danger</b-button>
          <b-button variant="outline-blue">outline-blue</b-button>
          <b-button variant="facebook">facebook</b-button>
          <b-button variant="select">select</b-button>
        </FormGroupHorizontal>
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Hover'"
          :split="'2:10'"
        >
          <b-button class="hover" variant="default">default</b-button>
          <b-button class="hover" variant="blue">blue</b-button>
          <b-button class="hover" variant="lightBlue">lightBlue</b-button>
          <b-button class="hover" variant="dark">dark</b-button>
          <b-button class="hover" variant="orange">orange</b-button>
          <b-button class="hover" variant="danger">danger</b-button>
          <b-button class="hover" variant="outline-blue">outline-blue</b-button>
          <b-button class="hover" variant="facebook">facebook</b-button>
          <b-button class="hover" variant="select">select</b-button>
        </FormGroupHorizontal>
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Focus'"
          :split="'2:10'"
        >
          <b-button class="focus" variant="default">default</b-button>
          <b-button class="focus" variant="blue">blue</b-button>
          <b-button class="focus" variant="lightBlue">lightBlue</b-button>
          <b-button class="focus" variant="dark">dark</b-button>
          <b-button class="focus" variant="orange">orange</b-button>
          <b-button class="focus" variant="danger">danger</b-button>
          <b-button class="focus" variant="outline-blue">outline-blue</b-button>
          <b-button class="focus" variant="facebook">facebook</b-button>
          <b-button class="focus" variant="select">select</b-button>
        </FormGroupHorizontal>
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Active'"
          :split="'2:10'"
        >
          <b-button class="active" variant="default">default</b-button>
          <b-button class="active" variant="blue">blue</b-button>
          <b-button class="active" variant="lightBlue">lightBlue</b-button>
          <b-button class="active" variant="dark">dark</b-button>
          <b-button class="active" variant="orange">orange</b-button>
          <b-button class="active" variant="danger">danger</b-button>
          <b-button class="active" variant="outline-blue">outline-blue</b-button>
          <b-button class="active" variant="facebook">facebook</b-button>
          <b-button class="active" variant="select">select</b-button>
        </FormGroupHorizontal>
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Disabled'"
          :split="'2:10'"
        >
          <b-button disabled variant="default">default</b-button>
          <b-button disabled variant="blue">blue</b-button>
          <b-button disabled variant="lightBlue">lightBlue</b-button>
          <b-button disabled variant="dark">dark</b-button>
          <b-button disabled variant="orange">orange</b-button>
          <b-button disabled variant="danger">danger</b-button>
          <b-button disabled variant="outline-blue">outline-blue</b-button>
          <b-button disabled variant="facebook">facebook</b-button>
          <b-button disabled variant="select">select</b-button>
        </FormGroupHorizontal>
      </div>
      <div class="col-12">
        <TitleSidebar class="mt-gd-2" :tag="'div'" :label="'Color Transparent'" />
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Normal'"
          :split="'2:10'"
        >
          <b-button variant="transparent">transparent</b-button>
          <b-button variant="transparent-lightBlue">tpr-lightBlue</b-button>
        </FormGroupHorizontal>
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Hover'"
          :split="'2:10'"
        >
          <b-button class="hover" variant="transparent">transparent</b-button>
          <b-button class="hover" variant="transparent-lightBlue">tpr-lightBlue</b-button>
        </FormGroupHorizontal>
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Focus'"
          :split="'2:10'"
        >
          <b-button class="focus" variant="transparent">transparent</b-button>
          <b-button class="focus" variant="transparent-lightBlue">tpr-lightBlue</b-button>
        </FormGroupHorizontal>
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Active'"
          :split="'2:10'"
        >
          <b-button class="active" variant="transparent">transparent</b-button>
          <b-button class="active" variant="transparent-lightBlue">tpr-lightBlue</b-button>
        </FormGroupHorizontal>
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Disabled'"
          :split="'2:10'"
        >
          <b-button disabled variant="transparent">transparent</b-button>
          <b-button disabled variant="transparent-lightBlue">tpr-lightBlue</b-button>
        </FormGroupHorizontal>
      </div>
    </div>

    <div class="row my-gd-4">
      <div class="col-12"><TitleSidebar :label="'Badge'" /></div>
      <div class="col-12">
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Color'"
          :split="'2:10'"
        >
          <b-badge variant="blue">blue</b-badge>
          <b-badge variant="blue2">blue2</b-badge>
          <b-badge variant="purple">purple</b-badge>
          <b-badge variant="green">green</b-badge>
          <b-badge variant="yellow">yellow</b-badge>
          <b-badge variant="orange">orange</b-badge>
          <b-badge variant="red">red</b-badge>
        </FormGroupHorizontal>
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Color Inverse'"
          :split="'2:10'"
        >
          <b-badge variant="inverse-blue">inverse-blue</b-badge>
          <b-badge variant="inverse-blue2">inverse-blue2</b-badge>
          <b-badge variant="inverse-purple">inverse-purple</b-badge>
          <b-badge variant="inverse-green">inverse-green</b-badge>
          <b-badge variant="inverse-yellow">inverse-yellow</b-badge>
          <b-badge variant="inverse-orange">inverse-orange</b-badge>
          <b-badge variant="inverse-red">inverse-red</b-badge>
        </FormGroupHorizontal>
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Theme'"
          :split="'2:10'"
        >
          <b-badge variant="default">default</b-badge>
          <b-badge variant="primary">primary</b-badge>
          <b-badge variant="secondary">secondary</b-badge>
          <b-badge variant="success">success</b-badge>
          <b-badge variant="danger">danger</b-badge>
          <b-badge variant="warning">warning</b-badge>
          <b-badge variant="light">light</b-badge>
          <b-badge variant="dark">dark</b-badge>
        </FormGroupHorizontal>
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Ex. Order Status'"
          :split="'2:10'"
        >
          <b-badge variant="yellow">Wait Payment</b-badge>
          <b-badge variant="orange">Wait Confirm</b-badge>
          <b-badge variant="blue">Wait Shipping</b-badge>
          <b-badge variant="purple">Cash On Delivery</b-badge>
          <b-badge variant="green">Shipped</b-badge>
          <b-badge variant="red">Expired</b-badge>
          <b-badge variant="hint">Cancel</b-badge>
        </FormGroupHorizontal>
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Ex. Contact Status'"
          :split="'2:10'"
        >
          <b-badge variant="orange">Waiting for Reply</b-badge>
          <b-badge variant="green">Replied</b-badge>
        </FormGroupHorizontal>
      </div>
    </div>

    <div class="row my-gd-4">
      <div class="col-12"><TitleSidebar :label="'Pagination'" /></div>
      <div class="col-12">
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Normal'"
          :split="'2:10'"
        >
        </FormGroupHorizontal>
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'With NumItem'"
          :split="'2:10'"
        >
        </FormGroupHorizontal>
      </div>
    </div>

    <div class="row my-gd-4">
      <div class="col-12"><TitleSidebar :label="'Toastification'" /></div>
      <div class="col-12">
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Color'"
          :split="'2:10'"
        >
        </FormGroupHorizontal>
      </div>
    </div>

    <div class="row my-gd-4">
      <div class="col-12"><TitleSidebar :label="'Input'" /></div>
      <div class="col-12">
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Size'"
          :split="'2:10'"
        >
          <div class="row align-items-center">
            <div class="col"><b-form-input size="sm" placeholder="placeholder"/></div>
            <div class="col"><b-form-input placeholder="placeholder"/></div>
            <div class="col"><b-form-input size="lg" placeholder="placeholder"/></div>
          </div>
        </FormGroupHorizontal>
      </div>
    </div>

    <div class="row my-gd-4">
      <div class="col-12"><TitleSidebar :label="'Input Unit'" /></div>
      <div class="col-12">
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Pixel'"
          :split="'2:10'"
        >
          <div class="row align-items-center">
            <div class="col-2"><b-form-input class="form-control-pixel" :unit="'pixel'" value="10"/></div>
            <div class="col-2"><b-form-input class="form-control-pixel text-center" :unit="'pixel'" value="10"/></div>
            <div class="col-2"><b-form-input class="form-control-pixel text-right" :unit="'pixel'" value="10"/></div>
          </div>
        </FormGroupHorizontal>
      </div>
    </div>

    <div class="row my-gd-4">
      <div class="col-12"><TitleSidebar :label="'Input Padding'" /></div>
      <div class="col-12">
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Callback Input'"
          :split="'2:10'"
        >
          <div class="row">
            <div class="col-4">
              <InputPadding
                :sync="paddingLink1.paddingSync"
                :top="paddingLink1.paddingTop"
                :left="paddingLink1.paddingLeft"
                :right="paddingLink1.paddingRight"
                :bottom="paddingLink1.paddingBottom"
                @input="inputPaddingLink"
              />
            </div>
            <div class="col-8">
              <pre style='font-size: 10px;'>paddingLink1 = {{ paddingLink1 }}</pre>
            </div>
          </div>
        </FormGroupHorizontal>
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Callback Change'"
          :split="'2:10'"
        >
          <div class="row">
            <div class="col-4">
              <InputPadding
                :sync="paddingLink2.paddingSync"
                :top="paddingLink2.paddingTop"
                :left="paddingLink2.paddingLeft"
                :right="paddingLink2.paddingRight"
                :bottom="paddingLink2.paddingBottom"
                @change="changePaddingLink"
              />
            </div>
            <div class="col-8">
              <pre style='font-size: 10px;'>paddingLink2 = {{ paddingLink2 }}</pre>
            </div>
          </div>
        </FormGroupHorizontal>
      </div>
    </div>

    <div class="row my-gd-4">
      <div class="col-12"><TitleSidebar :label="'Select'" /></div>
      <div class="col-12">
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Dropdown + .btn-select'"
          :split="'2:3'"
        >
          <b-dropdown text="Dropdown Button" variant="select">
            <b-dropdown-item>First Action</b-dropdown-item>
            <b-dropdown-item>Second Action</b-dropdown-item>
            <b-dropdown-item>Third Action</b-dropdown-item>
            <b-dropdown-item active>Active action</b-dropdown-item>
            <b-dropdown-item disabled>Disabled action</b-dropdown-item>
          </b-dropdown>
        </FormGroupHorizontal>

        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Dropdown + .dropdown-select'"
          :split="'2:3'"
        >
          <b-dropdown class="dropdown-select" text="Dropdown Button" variant="default">
            <b-dropdown-item>First Action</b-dropdown-item>
            <b-dropdown-item>Second Action</b-dropdown-item>
            <b-dropdown-item>Third Action</b-dropdown-item>
            <b-dropdown-item active>Active action</b-dropdown-item>
            <b-dropdown-item disabled>Disabled action</b-dropdown-item>
          </b-dropdown>
        </FormGroupHorizontal>
        
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'NormalSelect'"
          :split="'2:3'"
        >
          <NormalSelect
            :selected="valueNormalSelect"
            :options="optionsNormalSelect"
            :optionValue="'value'"
            :optionLabel="'label'"
            :conditions="[{
              key: 'isEnable',
              matchValue: false,
              content: ' <i class=\'far fa-eye-slash text-hint\'></i>',
            }, {
              key: 'disabled',
              matchValue: true,
              content: `<span class=\'ml-10\'>(Already Used)</span>`,
            }]"
            @change="(value) => { valueNormalSelect = value }"
          />
        </FormGroupHorizontal>

        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'TreeSelect'"
          :split="'2:3'"
        >
          <TreeSelect
            :selected="valueTreeSelect"
            :options="optionsTreeSelect"
            :optionValue="'value'"
            :optionLabel="'label'"
            :conditions="[{
              key: 'isEnable',
              matchValue: false,
              content: ' <i class=\'far fa-eye-slash text-hint\'></i>',
            }, {
              key: 'disabled',
              matchValue: true,
              content: `<span class=\'ml-10\'>(Already Used)</span>`,
            }]"
            @change="(value) => { valueTreeSelect = value }"
          />
        </FormGroupHorizontal>
      </div>
    </div>

    <div class="row my-gd-4">
      <div class="col-12"><TitleSidebar :label="'Form'" /></div>
      <div class="col-12">
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Label'"
          :labelHint="'TH'"
          :labelHelp="'???'"
          :labelRequired="true"
          :split="'2:10'"
        >
          <div class="row">
            <div class="col fs-sa-14">Normal</div>
            <div class="col fs-sa-14">Read Only</div>
            <div class="col fs-sa-14">Disabled</div>
            <div class="col fs-sa-14">Error</div>
          </div>
        </FormGroupHorizontal>

        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Input'"
          :split="'2:10'"
        >
          <div class="row">
            <div class="col"><b-form-input placeholder="placeholder"/></div>
            <div class="col"><b-form-input placeholder="placeholder" readonly/></div>
            <div class="col"><b-form-input placeholder="placeholder" disabled/></div>
            <div class="col errors">
              <b-form-input placeholder="placeholder"/>
              <small>Something wrong</small>
            </div>
          </div>
        </FormGroupHorizontal>

        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'NormalSelect'"
          :split="'2:10'"
        >
          <div class="row">
            <div class="col">
              <NormalSelect
                :selected="valueNormalSelect"
                :options="optionsNormalSelect"
                :optionValue="'value'"
                :optionLabel="'label'"
                :conditions="[{
                  key: 'isEnable',
                  matchValue: false,
                  content: ' <i class=\'far fa-eye-slash text-hint\'></i>',
                }, {
                  key: 'disabled',
                  matchValue: true,
                  content: `<span class=\'ml-10\'>(Already Used)</span>`,
                }]"
                @change="(value) => { valueNormalSelect = value }"
              />
            </div>
            <div class="col">
              <NormalSelect
                :selected="valueNormalSelect"
                :options="optionsNormalSelect"
                :optionValue="'value'"
                :optionLabel="'label'"
                :conditions="[{
                  key: 'isEnable',
                  matchValue: false,
                  content: ' <i class=\'far fa-eye-slash text-hint\'></i>',
                }, {
                  key: 'disabled',
                  matchValue: true,
                  content: `<span class=\'ml-10\'>(Already Used)</span>`,
                }]"
                readonly
                @change="(value) => { valueNormalSelect = value }"
              />
            </div>
            <div class="col">
              <NormalSelect
                :selected="valueNormalSelect"
                :options="optionsNormalSelect"
                :optionValue="'value'"
                :optionLabel="'label'"
                :conditions="[{
                  key: 'isEnable',
                  matchValue: false,
                  content: ' <i class=\'far fa-eye-slash text-hint\'></i>',
                }, {
                  key: 'disabled',
                  matchValue: true,
                  content: `<span class=\'ml-10\'>(Already Used)</span>`,
                }]"
                disabled
                @change="(value) => { valueNormalSelect = value }"
              />
            </div>
            <div class="col errors">
              <NormalSelect
                :selected="valueNormalSelect"
                :options="optionsNormalSelect"
                :optionValue="'value'"
                :optionLabel="'label'"
                :conditions="[{
                  key: 'isEnable',
                  matchValue: false,
                  content: ' <i class=\'far fa-eye-slash text-hint\'></i>',
                }, {
                  key: 'disabled',
                  matchValue: true,
                  content: `<span class=\'ml-10\'>(Already Used)</span>`,
                }]"
                @change="(value) => { valueNormalSelect = value }"
              />
              <small>Something wrong</small>
            </div>
          </div>
        </FormGroupHorizontal>

        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'TreeSelect'"
          :split="'2:10'"
        >
          <div class="row">
            <div class="col">
              <TreeSelect
                :selected="valueTreeSelect"
                :options="optionsTreeSelect"
                :optionValue="'value'"
                :optionLabel="'label'"
                :conditions="[{
                  key: 'isEnable',
                  matchValue: false,
                  content: ' <i class=\'far fa-eye-slash text-hint\'></i>',
                }, {
                  key: 'disabled',
                  matchValue: true,
                  content: `<span class=\'ml-10\'>(Already Used)</span>`,
                }]"
                @change="(value) => { valueTreeSelect = value }"
              />
            </div>
            <div class="col">
              <TreeSelect
                :selected="valueTreeSelect"
                :options="optionsTreeSelect"
                :optionValue="'value'"
                :optionLabel="'label'"
                :conditions="[{
                  key: 'isEnable',
                  matchValue: false,
                  content: ' <i class=\'far fa-eye-slash text-hint\'></i>',
                }, {
                  key: 'disabled',
                  matchValue: true,
                  content: `<span class=\'ml-10\'>(Already Used)</span>`,
                }]"
                readonly
                @change="(value) => { valueTreeSelect = value }"
              />
            </div>
            <div class="col">
              <TreeSelect
                :selected="valueTreeSelect"
                :options="optionsTreeSelect"
                :optionValue="'value'"
                :optionLabel="'label'"
                :conditions="[{
                  key: 'isEnable',
                  matchValue: false,
                  content: ' <i class=\'far fa-eye-slash text-hint\'></i>',
                }, {
                  key: 'disabled',
                  matchValue: true,
                  content: `<span class=\'ml-10\'>(Already Used)</span>`,
                }]"
                disabled
                @change="(value) => { valueTreeSelect = value }"
              />
            </div>
            <div class="col errors">
              <TreeSelect
                :selected="valueTreeSelect"
                :options="optionsTreeSelect"
                :optionValue="'value'"
                :optionLabel="'label'"
                :conditions="[{
                  key: 'isEnable',
                  matchValue: false,
                  content: ' <i class=\'far fa-eye-slash text-hint\'></i>',
                }, {
                  key: 'disabled',
                  matchValue: true,
                  content: `<span class=\'ml-10\'>(Already Used)</span>`,
                }]"
                @change="(value) => { valueTreeSelect = value }"
              />
              <small>Something wrong</small>
            </div>
          </div>
        </FormGroupHorizontal>

        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Textarea'"
          :split="'2:10'"
        >
          <div class="row">
            <div class="col"><b-form-textarea placeholder="placeholder"/></div>
            <div class="col"><b-form-textarea placeholder="placeholder" readonly/></div>
            <div class="col"><b-form-textarea placeholder="placeholder" disabled/></div>
            <div class="col errors">
              <b-form-textarea placeholder="placeholder"/>
              <small>Something wrong</small>
            </div>
          </div>
        </FormGroupHorizontal>

        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Input Group'"
          :split="'2:10'"
        >
          <div class="row">
            <div class="col">
              <b-input-group prepend="?">
                <b-form-input placeholder="placeholder"/>
              </b-input-group>
            </div>
            <div class="col">
              <b-input-group prepend="?">
                <b-form-input placeholder="placeholder" readonly/>
              </b-input-group>
            </div>
            <div class="col">
              <b-input-group prepend="?">
                <b-form-input placeholder="placeholder" disabled/>
              </b-input-group>
            </div>
            <div class="col errors">
              <b-input-group prepend="?">
                <b-form-input placeholder="placeholder"/>
              </b-input-group>
              <small>Something wrong</small>
            </div>
          </div>
          <div class="row mt-gd-2">
            <div class="col">
              <b-input-group append="?">
                <b-form-input placeholder="placeholder"/>
              </b-input-group>
            </div>
            <div class="col">
              <b-input-group append="?">
                <b-form-input placeholder="placeholder" readonly/>
              </b-input-group>
            </div>
            <div class="col">
              <b-input-group append="?">
                <b-form-input placeholder="placeholder" disabled/>
              </b-input-group>
            </div>
            <div class="col errors">
              <b-input-group append="?">
                <b-form-input placeholder="placeholder"/>
              </b-input-group>
              <small>Something wrong</small>
            </div>
          </div>
          <div class="row mt-gd-2">
            <div class="col">
              <b-input-group prepend="?" append="?">
                <b-form-input placeholder="placeholder"/>
              </b-input-group>
            </div>
            <div class="col">
              <b-input-group prepend="?" append="?">
                <b-form-input placeholder="placeholder" readonly/>
              </b-input-group>
            </div>
            <div class="col">
              <b-input-group prepend="?" append="?">
                <b-form-input placeholder="placeholder" disabled/>
              </b-input-group>
            </div>
            <div class="col errors">
              <b-input-group prepend="?" append="?">
                <b-form-input placeholder="placeholder"/>
              </b-input-group>
              <small>Something wrong</small>
            </div>
          </div>
        </FormGroupHorizontal>

        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Switcher'"
          :split="'2:10'"
        >
          <div class="row">
            <div class="col"><Switcher v-model="switcherValue"/></div>
            <div class="col"><Switcher v-model="switcherValue" readonly/></div>
            <div class="col"><Switcher v-model="switcherValue" disabled/></div>
            <div class="col errors">
              <Switcher v-model="switcherValue"/>
              <small>Something wrong</small>
            </div>
          </div>
        </FormGroupHorizontal>

        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Radio'"
          :split="'2:10'"
        >
          <div class="row">
            <div class="col"></div>
            <div class="col"></div>
            <div class="col"></div>
            <div class="col errors"></div>
          </div>
        </FormGroupHorizontal>

        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Checkbox'"
          :split="'2:10'"
        >
          <div class="row">
            <div class="col">
              <b-form-checkbox
                v-model="checkboxValue"
                value="1"
                unchecked-value="0"
              />
            </div>
            <div class="col">
              <b-form-checkbox
                v-model="checkboxValue"
                value="1"
                unchecked-value="0"
                readonly
              />
            </div>
            <div class="col">
              <b-form-checkbox
                v-model="checkboxValue"
                value="1"
                unchecked-value="0"
                disabled
              />
            </div>
            <div class="col errors">
              <b-form-checkbox
                v-model="checkboxValue"
                value="1"
                unchecked-value="0"
              />
              <small>Something wrong</small>
            </div>
          </div>
        </FormGroupHorizontal>

        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'Button'"
          :split="'2:10'"
        >
          <div class="row">
            <div class="col">
              <b-button variant="blue">Save</b-button>
              <b-button variant="default">Cancel</b-button>
            </div>
            <div class="col">
              <b-button variant="blue">Save</b-button>
              <b-button variant="default">Cancel</b-button>
            </div>
            <div class="col">
              <b-button variant="blue" disabled>Save</b-button>
              <b-button variant="default" disabled>Cancel</b-button>
            </div>
            <div class="col errors">
              <b-button variant="blue" disabled>Save</b-button>
              <b-button variant="default">Cancel</b-button>
            </div>
          </div>
        </FormGroupHorizontal>
      </div>
    </div>

    <div class="row my-gd-4">
      <div class="col-12"><TitleSidebar :label="'Image Browse'" /></div>
      <div class="col-12">
        <div class="row mt-gd-2">
            <div class="col-4">
              <ImageBrowse 
                :image="''" 
                @change="() => {}" 
              />
            </div>
          </div>
      </div>
    </div>

    <div class="row my-gd-4">
      <div class="col-12"><TitleSidebar :label="'Color'" /></div>
      <div class="col-12">
        <FormGroupHorizontal 
          class="mt-gd-2"
          :label="'ColorDisplay'"
          :split="'2:10'"
        >
          <div class="row">
            <div class="col-auto"><ColorDisplay :color="'#000000'" /></div>
            <div class="col-auto"><ColorDisplay :color="'#EEEEEE'" /></div>
            <div class="col-auto"><ColorDisplay :color="'#FFFFFF'" /></div>
          </div>
        </FormGroupHorizontal>
      </div>
    </div>
            

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FormGroupHorizontal from '@components_system/Shared/Tools/FormGroupHorizontal/FormGroupHorizontal';
import TitleSidebar from "@components_system/Shared/Elements/Texts/TitleSidebar";
import TitleModal from "@components_system/Shared/Elements/Texts/TitleModal";
import TitleDesign from "@components_system/Shared/Elements/Texts/TitleDesign";
import TitleSetting from "@components_system/Shared/Elements/Texts/TitleSetting";
import FormLabel from "@components_system/Shared/Elements/Texts/FormLabel";
import NormalSelect from "@components_system/Shared/Tools/NormalSelect/NormalSelect";
import TreeSelect from "@components_system/Shared/Tools/TreeSelect/TreeSelect";
import Switcher from "@components_system/Shared/Tools/Switcher/Switcher";
import ImageBrowse from "@components_system/Shared/Tools/ImageBrowse/ImageBrowse";
import InputPadding from "@components_system/Shared/Tools/InputPadding/InputPadding";
import ColorDisplay from "@components_system/Shared/Tools/ColorDisplay/ColorDisplay";

export default {
  components: {
    FormGroupHorizontal,
    TitleSidebar,
    TitleModal,
    TitleDesign,
    TitleSetting,
    FormLabel,
    NormalSelect,
    TreeSelect,
    Switcher,
    ImageBrowse,
    InputPadding,
    ColorDisplay,
  },
  computed: {
    ...mapGetters({
      languageUse: "design/site/languageUse",
      languageEngine: "design/userPreference/languageEngine",
    }),
  },
  data() {
    return {
      checkboxValue: true,
      switcherValue: true,
      valueNormalSelect: '0',
      optionsNormalSelect: [
        { value: '0', label: 'All', isEnable: true },
        { value: '1', label: 'option 1', isEnable: true },
        { value: '2', label: 'option 2', isEnable: false },
        { value: '3', label: 'option 3', isEnable: true, disabled: true },
        // { value: 99, label: 'optionnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnn 99' },
      ],
      valueTreeSelect: '1-2',
      optionsTreeSelect: [
        { value: '0', label: 'All', isEnable: true },
        { value: '1', label: 'option 1', isEnable: true, children: [
          { value: '2', label: 'option 2', isEnable: true, children: [
            { value: '3', label: 'option 3', isEnable: true, children: [
              { value: '4', label: 'option 4', isEnable: true },
            ]},
          ]},
        ]},
        { value: '5', label: 'option 5', isEnable: false },
        { value: '6', label: 'option 6', isEnable: true, disabled: true },
        // { value: 99, label: 'optionnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnn 99' },
      ],
      paddingLink1: {
        paddingSync: true,
        paddingTop: 15,
        paddingLeft: 16,
        paddingRight: 17,
        paddingBottom: 18,
      },
      paddingLink2: {
        paddingSync: true,
        paddingTop: 15,
        paddingLeft: 16,
        paddingRight: 17,
        paddingBottom: 18,
      },
    };
  },
  methods: {
    inputPaddingLink(value) {
      this.paddingLink1 = {
        paddingSync: value.sync,
        paddingTop: value.top,
        paddingLeft: value.left,
        paddingRight: value.right,
        paddingBottom: value.bottom,
      };
    },
    changePaddingLink(value) {
      this.paddingLink2 = {
        paddingSync: value.sync,
        paddingTop: value.top,
        paddingLeft: value.left,
        paddingRight: value.right,
        paddingBottom: value.bottom,
      };
    }
  },
};
</script>

<style></style>